// extracted by mini-css-extract-plugin
export default {"speakerOffset":"SpeakersByEventDisplayStyle_speakerOffset__gxoLn","siteOffset":"SpeakersByEventDisplayStyle_siteOffset__hsFyF"};